
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investors",
      function () {
        return require("private-next-pages/investors.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investors"])
      });
    }
  